import React, {Component} from 'react';
import {Buffer} from "buffer";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import withAuth from "../../hoc/withAuth";
import {offerApiServices} from "../../services/offer/OfferApiService";
import {ocrIdCardImageService} from "../../services/ocrImage/OcrIdCardImageService";
import type {MenuProps} from 'antd'
import {Button, DatePicker, Dropdown, Divider, Form, Input, Menu, message, Modal, Select, Table, Tag, Tooltip, Row, Col, Spin} from 'antd';
import {FilePdfOutlined, CheckCircleTwoTone, CopyOutlined, DownOutlined, EditOutlined, ExceptionOutlined, ExclamationCircleOutlined, ExportOutlined, FormOutlined, NotificationOutlined, ScheduleOutlined, SearchOutlined, SolutionOutlined, ThunderboltOutlined, WarningOutlined} from "@ant-design/icons";
import {ListOfferStates} from "./types/ListOfferTypes";
import moment from "moment";
import AreaGroupCitySelect from "../../components/area/AreaGroupCitySelect";
import DetailOffer from "../../components/offer/DetailOffer";
import Cookies from "universal-cookie";
import DetailOrder from "../../components/order/DetailOrder";
import UpdateOwnerOffer from "../../components/offer/UpdateOwnerOffer";
import UpdateOrderMakerOffer from "../../components/offer/UpdateOrderMakerOffer";
import UpdateShippingAddressOffer from "../../components/offer/UpdateShippingAddressOffer";
import UpdatePhoneNumber from "../../components/offer/UpdatePhoneNumber";
import currencyFormat from "../../helper/currencyFormat";
import UpdateVehicleAndPromo from "../../components/offer/UpdateVehicleAndPromo";
import CustomerIdCardOcr from "../../components/customer/CustomerIdCardOcr";
import TextArea from "antd/es/input/TextArea";

export interface ListOfferProps {
}

class ListOffer extends Component<ListOfferProps & any, ListOfferStates> {
    private readonly initState!: ListOfferStates;
    private user = JSON.parse(Buffer.from(new Cookies().get('_u'), "base64").toString());
    private accessLevel = ((cookieValue) => cookieValue ? JSON.parse(Buffer.from(cookieValue, "base64").toString()) : "")(new Cookies().get('_l'));
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());
    private token = new Cookies().get('_t');
    private tableColumn: any = [
        {
            title: 'Kode Offer',
            dataIndex: 'transaction_code',
            width: 180,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span style={!row.credit_different_po_data ? {display: 'none'} : {}}><Tooltip title="Data PO berbeda dengan data offer" color={'red'}><WarningOutlined className={'small-avatar-danger'}/>&nbsp;</Tooltip></span>
                        <span style={(!row?.color_code || !row?.variant_code) ? {} : {display: 'none'}}><span style={row.additionalOrderPolicy ? {display: 'none'} : {}}><Tooltip title={`Data Offer Tidak Lengkap`} color={'orange'}><ExclamationCircleOutlined className={'small-avatar-danger'}/> &nbsp;</Tooltip></span></span>
                        <span style={(!row?.bill_code) ? {} : {display: 'none'}}><span style={row.additionalOrderPolicy ? {display: 'none'} : {}}><Tooltip title={`Bill belum dibuat`} color={'orange'}><ExceptionOutlined className={'small-avatar-danger'}/> &nbsp;</Tooltip></span></span>
                        <span style={(row?.qc_status) ? {} : {display: 'none'}}><Tooltip title={`Sudah dilakukan QC`} color={'green'}><CheckCircleTwoTone twoToneColor="#52c41a"/> &nbsp;</Tooltip></span>
                        <span className={`font-90-link`} onClick={() => this.setState({chosenOfferCode: row.transaction_code, chosenOfferRow: row, showModalDetailStock: true})}>{value}</span>&nbsp;
                        <Tooltip title="Click untuk copy kode offer" color={'cyan'}><CopyOutlined className={'small-avatar-link'} onClick={event => this.copyToClipboard(value)}/></Tooltip>
                        <span style={!row.order_code ? {display: 'none'} : {fontSize: '60%'}}>
                            <br/><span style={{cursor: "pointer"}} onClick={event => this.showDetailOrder(row.order_code)}>{row.order_code}</span>
                        </span>
                        <div style={(this.state.filterOfferStatus?.toLowerCase() === 'open' && this.state.filterCityGroupCode) ? {} : {display: 'none'}}>
                            <span style={{fontSize: "80%"}}>available: {row?.additional_stock ?? "-"} | payment: {currencyFormat(row?.additional_paid) ?? "-"} </span>
                            <span style={row.additionalOrderPolicy ? {display: 'none'} : {}}>
                                <Tooltip title={`Minimum Kebijakan Order ${currencyFormat(row?.additionalOrderPolicyMinimumPaid)}`} color={'orange'}>
                                    <WarningOutlined className={'small-avatar-danger'}/>
                                </Tooltip>
                            </span>
                        </div>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Status',
            dataIndex: 'offer_status',
            width: 132,
            render: ((value: string, row: any) => {
                let area = <span style={{fontSize: '85%'}} className={`font-90`}>{`${row?.area.toUpperCase()}`}</span>;
                let purcahseMethod = (row?.purchase_method === 'cash') ? <Tag style={{fontSize: "70%", display: "inline"}} color="#f50">Tunai</Tag> : <Tag style={{fontSize: "70%", display: "inline"}} color="#87d068">Kredit</Tag>;
                let status: any = "-";
                if (value.toUpperCase() === 'OPEN') {
                    status = <Tag style={{fontSize: "70%", display: "inline"}} color="#108ee9">Open</Tag>;
                } else if (value.toUpperCase() === 'CANCEL') {
                    status = <Tag style={{fontSize: "70%", display: "inline"}} color="#f50">{(row?.cancel_admin_id === 'SYSTEM') ? "Cancel System" : "Cancel"}</Tag>;
                } else if (value.toUpperCase() === 'ORDER') {
                    status = <Tag style={{fontSize: "70%", display: "inline"}} color="#87d068">Order</Tag>;
                }
                return (<React.Fragment>{area}<br/>{purcahseMethod}{status}</React.Fragment>)
            })
        },
        {
            title: 'Tgl Transaksi',
            dataIndex: 'transaction_time',
            width: 140,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span style={{fontSize: "85%"}} className={`font-90`}>{`${value.substring(0, 10)}`}</span><br/>
                        <span style={!row?.survey_created_time ? {display: 'none'} : {}}>
                            <Tooltip title="Tanggal Form Kredit Dibuat" color={'cyan'}><ExportOutlined style={{fontSize: "70%", cursor: "help"}}/></Tooltip>
                            <span style={{fontSize: "65%", paddingLeft: 3}} className={`font-90`}>{`${row?.survey_created_time?.substring(0, 10)}`}</span>
                        </span> &nbsp;
                        <span style={(!row?.po_time || row?.purchase_method === 'cash') ? {display: 'none'} : {}}>
                            <Tooltip title="Tanggal PO" color={'cyan'}><FormOutlined style={{fontSize: "70%", cursor: "help"}}/></Tooltip>
                            <span style={{fontSize: "65%", paddingLeft: 3}} className={`font-90`}>{`${row?.po_time?.substring(0, 10)}`}</span>
                        </span>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Nama Pemilik',
            dataIndex: 'owner_full_name',
            width: 120,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span className={`font-80`}>{`${(value.length < 14) ? value?.toUpperCase() : value?.toUpperCase()?.substring(0, 12) + "..."}`}</span><br/>
                        <span style={this.accessLevel === "OWNER" ? {cursor: "pointer"} : {display: "none"}} onClick={event => this.showOcrForm(row)} className={`font-75-grey`}>{`${row?.owner_id_card_number}`}</span>
                        <span style={this.accessLevel !== "OWNER" ? {} : {display: "none"}} className={`font-75-grey`}>{`${row?.owner_id_card_number}`}</span>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Agen | Promo',
            dataIndex: 'agent_code',
            width: 120,
            render: ((value: string, row: any) => {
                return <React.Fragment>
                <span className={`font-80`}>
                    <span style={(!row?.amarta_vip_uid) ? {display: 'none'} : {}}>
                        <Tooltip title={`User AmartaVip ${row?.amarta_vip_uid}`} color={'cyan'}><ThunderboltOutlined style={{fontSize: "110%", fontWeight: "bold", color: "#3d8342", cursor: "help"}}/></Tooltip>&nbsp;
                    </span>

                    {`${(row?.affiliate_code && (row?.affiliate_code !== "NO_DATA")) ? row?.affiliate_code : ""}`}
                    {`${(value && (value !== "NO_DATA")) ? value : ""}`}
                    <br/>
                    <span style={{fontSize: "70%"}}>{row?.promo_codes?.toString()}</span>
                </span>
                </React.Fragment>
            })
        },
        {
            title: 'Tipe Variant',
            dataIndex: 'variant_name',
            width: 150,
            render: ((value: string, row: any) => {
                return <React.Fragment> <span className={`font-85-red`}>{row.variant_code}</span><br/><span className={`font-85-grey`}>{value}</span></React.Fragment>
            })
        },
        {
            title: 'Warna',
            dataIndex: 'color_name',
            width: 150,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span className={`font-90`}>{row.color_code} - {value}</span><br/>
                        <span className={`font-75-grey`} style={!row?.color_alternative ? {display: 'none'} : {}}>
                            <Tooltip title="Warna Alternatif" color={'cyan'}><NotificationOutlined style={{cursor: "help"}}/> {row?.color_alternative?.name}</Tooltip>
                        </span>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Sumber',
            dataIndex: 'source',
            width: 180,
            render: ((value: string, row: any) => {
                return (
                    <React.Fragment>
                        <span style={(!row?.amarta_vip_is_lead) ? {display: 'none'} : {}}><Tooltip title={`Konsumen berasal dari LeadAgent`} color={'cyan'}><SolutionOutlined style={{fontSize: "110%", fontWeight: "bold", color: "#3d8342", cursor: "help"}}/></Tooltip>&nbsp;</span>
                        <span className={`font-85-red`}>{`${value}`}</span><br/>
                        <span style={row?.purchase_method === 'cash' ? {display: 'none'} : {}}><span className={`font-75-grey`}>{`${row?.finco_code?.toUpperCase()}`}</span> - <span className={`font-75-grey`}>{`${row?.po_code?.toUpperCase()}`}</span></span>
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Action',
            key: 'operation',
            fixed: 'right',
            width: 100,
            render: ((row: any) => {
                const items: MenuProps['items'] = [
                    {key: '1', label: (<span onClick={() => this.setState({chosenOfferCode: row.transaction_code, chosenOfferRow: row, showModalDetailStock: true})}> <SearchOutlined/> Lihat Detail</span>)},
                    {key: '2', label: (<span onClick={() => this.copyToClipboard(`${row.area?.toUpperCase()} | ${(row?.purchase_method === "cash") ? "TUNAI" : "KREDIT | " + row.finco_code?.toUpperCase()} | ${row.owner_full_name?.toUpperCase()} | ${row.transaction_code} | ${row.variant_name?.toUpperCase()}-${row.color_name?.toUpperCase()}`)}> <CopyOutlined/> Copy Ringkasan</span>)},
                ];
                if (row?.offer_status?.toUpperCase() === "OPEN") {
                    items.push(
                        {key: '3', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, showModalUpdateOwner: true})} style={{cursor: "pointer"}}> <EditOutlined/> Edit Data Pemilik</span>)},
                        {key: '4', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, showModalUpdateOrderMaker: true})} style={{cursor: "pointer"}}> <EditOutlined/> Edit Data Pemesan</span>)},
                        {key: '5', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, chosenOfferRow: row, showModalUpdatePhoneNumber: true})} style={{cursor: "pointer"}}> <EditOutlined/> Edit Nomor Telpon</span>)},
                        {key: '6', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, showModalUpdateShippingAddress: true})} style={{cursor: "pointer"}}> <EditOutlined/> Edit Data Pengiriman</span>)},
                        {key: '7', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, showModalUpdateVehiclePromo: true})} style={{cursor: "pointer"}}> <EditOutlined/> Edit Kendaraan & Promo</span>)},
                        {key: '8', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, showModalDetailCreatePoPdf: true, poNotes: "", attorneyDealerName: "", attorneyEngineNumber: ""})} style={{cursor: "pointer"}}> <FilePdfOutlined/> Buat PO</span>)},
                    );
                }
                if (row?.offer_status?.toUpperCase() === "ORDER") {
                    items.push(
                        {key: '9', label: (<span onClick={event => this.setState({chosenOfferCode: row.transaction_code, showModalDetailCreateSnsPdf: true, poNotes: "", attorneyDealerName: "", attorneyEngineNumber: ""})} style={{cursor: "pointer"}}> <FilePdfOutlined/> Buat SNS</span>)},
                    );
                }

                return <React.Fragment>
                    <span className={`font-90`}>
                        <Dropdown menu={{items}} placement="bottomLeft" arrow>
                          <Button size={"small"} type={"primary"}> <ScheduleOutlined/> Aksi</Button>
                        </Dropdown>
                    </span>
                </React.Fragment>
            })
        }
    ]

    constructor(props: ListOfferProps & any | any) {
        super(props);
        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            processing: false,
            dealerCode: finalDealerCode,
            companyCode: companyCode,
            processingFetchTableData: false,
            dataOffer: [],
            pageSize: 100,
            showModalDetailStock: false,
            filterStartDate: moment().format('YYYY-MM-DD'),
            filterEndDate: moment().format('YYYY-MM-DD'),
            filterOfferStatus: "Open",
            filterPurchaseMethod: "",
            filterCityGroupCode: "",
            filterCityGroupName: "",
            filterCityGroupStockCode: "",
            chosenOfferCode: "",
            chosenOfferRow: {},
            detailOrderCode: "",
            detailOrderModal: false,
            updateOfferModal: false,
            chosenOfferUpdate: {},
            showModalUpdateOwner: false,
            showModalUpdateOrderMaker: false,
            showModalUpdatePhoneNumber: false,
            showModalUpdateShippingAddress: false,
            showModalUpdateVehiclePromo: false,
            searchType: "date",
            searchOfferCode: "",
            searchPoCode: "",
            qcShow: false,
            qcProcess: false,
            ocrProcess: false,
            ocrResultName: null,
            ocrResultNumber: null,
            chosenIdCardNumber: "",
            chosenIdCardImage: "",
            showModalDetailIdCard: false,
            showModalDetailCreatePoPdf: false,
            showModalDetailCreateSnsPdf: false,
            poNotes: "",
            attorneyDealerName: "",
            attorneyEngineNumber: "",
            additionalCostType: "",
            additionalCostBpdab: "",
            additionalCostBpdad: "",
            additionalCostBpkon: "",
            additionalBureauFee: "",
            additionalPdi: "",
            additionalPelwil: "",
            additionalTol: "",
            additionalDifferenceOtr: "",
            createPaymentShow: false,
            createPaymentProcess: false,
        }
        this.state = {...this.initState}
    }

    onCloseEditModal = () => {
        this.setState({
            showModalUpdatePhoneNumber: false,
            showModalUpdateOrderMaker: false,
            showModalUpdateVehiclePromo: false,
            showModalUpdateOwner: false,
            showModalUpdateShippingAddress: false,
        });
        this.fetchOffer();
    }

    showDetailOrder = async (code: any) => {
        this.setState({
            detailOrderCode: code,
            detailOrderModal: true,
        })
    }

    copyResume = async () => {
        if (this.state.dataOffer.length === 0) {
            await navigator.clipboard.writeText("");
            message.info('Tidak ada data yang di copy');
            return;
        }
        let finalText = "";
        for (const row of this.state.dataOffer) {
            finalText += `${row.area?.toUpperCase()} | ${(row?.purchase_method === "cash") ? "TUNAI" : "KREDIT | " + row.finco_code?.toUpperCase()} | ${row.owner_full_name?.toUpperCase()} | ${row.transaction_code} | ${row.variant_name?.toUpperCase()}-${row.color_name?.toUpperCase()}\n`;
        }

        await navigator.clipboard.writeText(finalText);
        message.info('Resume Berhasil di Copy');
    }

    copyToClipboard = async (data: any) => {
        await navigator.clipboard.writeText(data);
        message.info('Kode Berhasil di Copy');
    }

    finalQc = async () => {
        await this.promisedSetState({qcProcess: true});
        try {
            await offerApiServices.setToken(this.token);
            await offerApiServices.updateOffer({
                update_type: "qc-offer",
                company: this.state.companyCode,
                admin_id: this.user,
                admin_name: this.user,
                offer_code: this.state.chosenOfferCode,
                additional_cost_type: this.state.additionalCostType,
                additional_cost_detail: {
                    bpdead: this.state.additionalCostBpdab,
                    bpdeab: this.state.additionalCostBpdad,
                    bpkon: this.state.additionalCostBpkon,
                    bureau_fee: this.state.additionalBureauFee,
                    pdi: this.state.additionalPdi,
                    pelwil: this.state.additionalPelwil,
                    tol: this.state.additionalTol,
                    difference_otr: this.state.additionalDifferenceOtr
                },
                id_card_owner_ocr: {
                    id_card_number: this.state.ocrResultNumber,
                    full_name: this.state.ocrResultName
                }
            }).then(async successData => {
                Modal.success({title: 'Proses Sukses', content: 'QC berhasil dilakukan'});
                await this.promisedSetState({qcProcess: false, ocrProcess: false, qcShow: false});
                this.fetchOffer();
            });
        } catch (e) {
            Modal.error({title: 'Proses Gagal', content: 'Server Menolak Inputan Anda :' + e});
            await this.promisedSetState({qcProcess: false, ocrProcess: false});
        }
    }

    createBill = async () => {
        await this.promisedSetState({createPaymentProcess: true});
        try {
            await offerApiServices.setToken(this.token);
            await offerApiServices.updateOffer({
                update_type: "create-bill-offer",
                company: this.state.companyCode,
                admin_id: this.user,
                admin_name: this.user,
                offer_code: this.state.chosenOfferCode
            }).then(async successData => {
                Modal.success({title: 'Proses Sukses', content: 'berhasil dilakukan'});
                await this.promisedSetState({createPaymentProcess: false, createPaymentShow: false});
                this.fetchOffer();
            });
        } catch (e) {
            Modal.error({title: 'Proses Gagal', content: 'Server Menolak Inputan Anda :' + e});
            await this.promisedSetState({createPaymentProcess: false,});
        }
    }

    showOcrForm = async (data: any) => {
        await this.promisedSetState({
            chosenIdCardNumber: data.owner_id_card_number,
            chosenIdCardImage: data.owner_id_card_image,
            showModalDetailIdCard: true,
        });
    }

    onDealerChange = async (data: any) => {
        await this.promisedSetState({
            dataOffer: [],
            dealerCode: data.value,
        });
    }

    fetchOffer = async () => {
        const diffDays = moment(this.state.filterEndDate).diff(moment(this.state.filterStartDate), 'days');
        if (diffDays > 14) {
            message.open({
                type: 'error',
                content: <span>Pencarian Data hanya dapat dilakukan dalam range 14 hari. <br/><br/> jika ingin mencari data januari 2021, tglAwal: 2021-01-01 dan tglAkhir: 2021-01-14 </span>,
                duration: 4,
            });
            return;
        }

        await this.promisedSetState({
            dataOffer: [],
            processingFetchTableData: true,
        });

        const payloadFetch = {
            companyCode: this.state.companyCode,
            area: this.state.filterCityGroupCode,
            areaStock: this.state.filterCityGroupStockCode,
            status: this.state.filterOfferStatus,
            purchaseMethod: this.state.filterPurchaseMethod,
            startDate: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
            endDate: moment(this.state.filterEndDate).format("YYYY-MM-DD"),
            additionalData: (this.state.filterOfferStatus?.toLowerCase() === 'open' && this.state.filterCityGroupCode) ? "order-policy-stock-payment" : null,
            searchType: this.state.searchType,
            searchOfferCode: this.state.searchOfferCode,
            searchPoCode: this.state.searchPoCode,
        }

        await offerApiServices.setToken(this.token);
        await offerApiServices.getOffer(
            payloadFetch
        ).then(async value => {
            let finalData = [];
            if (this.state.searchType === "duplicate_idcard") {
                let a = value.data.data
                let duplicates: any = [];
                let counts: any = {};

                for (let i = 0; i < a.length; i++) {
                    if (a[i].owner_id_card_number !== '9999999999999999' && a[i].owner_id_card_number !== 'nodata') {
                        if (counts[a[i].owner_id_card_number] === undefined) {
                            counts[a[i].owner_id_card_number] = 1;
                        } else {
                            counts[a[i].owner_id_card_number]++;
                            if (counts[a[i].owner_id_card_number] === 2) {
                                duplicates.push(a[i].owner_id_card_number);
                            }
                        }
                    }
                }
                finalData = a.filter((item: any) => duplicates.includes(item.owner_id_card_number));
                finalData.sort((a: any, b: any) => a.owner_id_card_number.localeCompare(b.owner_id_card_number));
            } else {
                finalData = value.data.data;
            }

            await this.promisedSetState({
                dataOffer: finalData,
                processingFetchTableData: false,
            });
        }).catch(async e => {
            await this.promisedSetState({
                dataOffer: [],
                processingFetchTableData: false,
            });
            message.error(e?.toString());
        });
    }

    onChangeTable = (pagination: any, filters: any, sorter: any) => {
        if (pagination?.pageSize) {
            this.setState({
                pageSize: pagination?.pageSize,
            });
        }
    }

    changeSearchType = async (type: string) => {
        await this.promisedSetState({
            searchType: type,
            searchOfferCode: "",
            searchPoCode: "",
        });

        if (type === "duplicate_idcard") {
            await this.promisedSetState({
                filterStartDate: moment().subtract(14, 'days').format('YYYY-MM-DD'),
                filterEndDate: moment().format('YYYY-MM-DD'),
                filterOfferStatus: "open",
                filterCityGroupCode: "",
                filterCityGroupStockCode: "",
            });
        }
    }


    onFieldChange = <T extends keyof Pick<any, "additionalTol" | "additionalDifferenceOtr" | "additionalBureauFee" | "additionalPdi" | "additionalPelwil" | "additionalCostBpdab" | "additionalCostBpdad" | "additionalCostBpkon" | "additionalCostType" | "attorneyDealerName" | "attorneyEngineNumber" | "poNotes" | "searchPoCode" | "searchOfferCode" | "filterStartDate" | "filterEndDate" | "filterOfferStatus" | "filterPurchaseMethod">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "additionalTol":
                currentState.additionalTol = value;
                break;
            case "additionalDifferenceOtr":
                currentState.additionalDifferenceOtr = value;
                break;
            case "additionalBureauFee":
                currentState.additionalBureauFee = value;
                break;
            case "additionalPdi":
                currentState.additionalPdi = value;
                break;
            case "additionalPelwil":
                currentState.additionalPelwil = value;
                break;
            case "additionalCostBpdab":
                currentState.additionalCostBpdab = value;
                break;
            case "additionalCostBpdad":
                currentState.additionalCostBpdad = value;
                break;
            case "additionalCostBpkon":
                currentState.additionalCostBpkon = value;
                break;
            case "additionalCostType":
                currentState.additionalCostType = value;
                currentState.additionalCostBpdab = value;
                currentState.additionalCostBpdad = value;
                currentState.additionalCostBpkon = value;
                currentState.additionalBureauFee = value;
                currentState.additionalPdi = value;
                currentState.additionalPelwil = value;
                currentState.additionalTol = value;
                currentState.additionalDifferenceOtr = value;
                break;
            case "attorneyDealerName":
                currentState.attorneyDealerName = value;
                break;
            case "attorneyEngineNumber":
                currentState.attorneyEngineNumber = value;
                break;
            case "poNotes":
                currentState.poNotes = value;
                break;
            case "searchPoCode":
                currentState.searchPoCode = value;
                break;
            case "searchOfferCode":
                currentState.searchOfferCode = value;
                break;
            case "filterStartDate":
                currentState.filterStartDate = value;
                break;
            case "filterEndDate":
                currentState.filterEndDate = value;
                break;
            case "filterOfferStatus":
                currentState.filterOfferStatus = value;
                if (value === "qc") {
                    currentState.searchType = "qc";
                } else {
                    currentState.searchType = "date";
                }
                break;
            case "filterPurchaseMethod":
                currentState.filterPurchaseMethod = value;
                break;
        }
        currentState.dataOffer = [];
        this.setState({
            ...currentState,
        });
    }

    onCityGroupChange = (data: any) => {
        this.setState({
            filterCityGroupCode: data.value,
            filterCityGroupName: data.children,
            filterCityGroupStockCode: data.value,
            dataOffer: [],
        });
    }

    onCityGroupStockChange = (data: any) => {
        this.setState({
            filterCityGroupStockCode: data.value,
            dataOffer: [],
        });
    }

    buttonQcHit = async () => {
        if (!this.state.chosenOfferRow.owner_id_card_image) {
            return Modal.error({title: 'Proses QC Gagal', content: 'Mohon lengkapi nama, nomor ktp, dan image KTP pemilik'});
        }
        this.setState({
            showModalDetailStock: false,
            qcShow: true,
            qcProcess: false,
            ocrProcess: true,
            ocrResultName: null,
            ocrResultNumber: null,
            additionalCostType: (this.state.chosenOfferRow?.agent_code === "NO_DATA") ? "BILL" : "INVOICE",
            additionalCostBpdab: (this.state.chosenOfferRow?.agent_code === "NO_DATA") ? "BILL" : "INVOICE",
            additionalCostBpdad: (this.state.chosenOfferRow?.agent_code === "NO_DATA") ? "BILL" : "INVOICE",
            additionalCostBpkon: (this.state.chosenOfferRow?.agent_code === "NO_DATA") ? "BILL" : "INVOICE",
            additionalBureauFee: (this.state.chosenOfferRow?.agent_code === "NO_DATA") ? "BILL" : "INVOICE",
            additionalPdi: (this.state.chosenOfferRow?.agent_code === "NO_DATA") ? "BILL" : "INVOICE",
            additionalPelwil: (this.state.chosenOfferRow?.agent_code === "NO_DATA") ? "BILL" : "INVOICE",
            additionalTol: (this.state.chosenOfferRow?.agent_code === "NO_DATA") ? "BILL" : "INVOICE",
            additionalDifferenceOtr: (this.state.chosenOfferRow?.agent_code === "NO_DATA") ? "BILL" : "INVOICE",
        })

        try {
            const dataOcr = await ocrIdCardImageService.getData({image_url: this.state.chosenOfferRow.owner_id_card_image});
            this.setState({
                ocrProcess: false,
                ocrResultName: dataOcr.data?.data?.name?.toUpperCase(),
                ocrResultNumber: dataOcr.data?.data?.id_card_number?.toUpperCase(),
            })
        } catch (e) {
            this.setState({
                ocrProcess: false,
                ocrResultName: "Error Text",
                ocrResultNumber: "Error Text",
            })
        }
    }

    promisedSetState = (newState: any) => new Promise((resolve: any) => this.setState(newState, resolve));

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Offer`} breadcrumbMenu={`List Offer`} defaultSelectedKeys={['m-list-offer']} defaultOpenKeys={['sm-offer']}>
                    <div style={{paddingLeft: 10, paddingRight: 10, paddingBottom: 20}}>
                        <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                        <br/>
                        <Form layout={`inline`} style={{marginTop: -3}}>
                            <Form layout={`inline`} style={this.state.searchType === "duplicate_idcard" ? {} : {display: 'none'}}>
                                <Form.Item className={'padTop-10'} style={{width: 260}}>
                                    <i className={`small-text-grey`}>Key</i>
                                    <Input disabled={true} value={`duplicate owner id-card last 2 weeks`}/>
                                </Form.Item>
                            </Form>
                            <Form layout={`inline`} style={this.state.searchType === "offer_code" ? {} : {display: 'none'}}>
                                <Form.Item className={'padTop-10'} style={{width: 230}}>
                                    <i className={`small-text-grey`}>Kode Offer</i>
                                    <Input value={this.state.searchOfferCode} onChange={event => this.onFieldChange("searchOfferCode", event.target.value)} placeholder="Kode Offer"/>
                                </Form.Item>
                            </Form>
                            <Form layout={`inline`} style={this.state.searchType === "po_code" ? {} : {display: 'none'}}>
                                <Form.Item className={'padTop-10'} style={{width: 230}}>
                                    <i className={`small-text-grey`}>Kode PO</i>
                                    <Input value={this.state.searchPoCode} onChange={event => this.onFieldChange("searchPoCode", event.target.value)} placeholder="Kode PO"/>
                                </Form.Item>
                            </Form>
                            <Form layout={`inline`} style={this.state.searchType === "qc" || this.state.searchType === "date" ? {} : {display: 'none'}}>
                                <Form.Item className={'padTop-10'} style={this.state.searchType !== "qc" ? {width: 150} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Area</i>
                                    <Tooltip title="Untuk memunculkan informasi ketersediaan kendaraan, silakan pilih area dan area stock" color={'cyan'}>
                                        <WarningOutlined style={{fontSize: "80%", marginLeft: 5, color: "#f4364c", cursor: "help"}}/>
                                    </Tooltip>
                                    <AreaGroupCitySelect companyCode={this.state.companyCode} onCityGroupChangeProps={this.onCityGroupChange} dealerCode={this.state.dealerCode} value={this.state.filterCityGroupCode}/>
                                </Form.Item>
                                <Form.Item className={'padTop-10'} style={this.state.searchType !== "qc" ? {width: 150} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Area Stock</i>
                                    <AreaGroupCitySelect companyCode={this.state.companyCode} onCityGroupChangeProps={this.onCityGroupStockChange} dealerCode={this.state.dealerCode} value={this.state.filterCityGroupStockCode}/>
                                </Form.Item>

                                <Form.Item className={'padTop-10'} style={this.state.searchType === "qc" || this.state.searchType === "date" ? {width: 100} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Status</i>
                                    <Select
                                        showSearch
                                        placeholder="Pilih Status"
                                        optionFilterProp="children"
                                        onChange={value => this.onFieldChange("filterOfferStatus", value)}
                                        value={this.state.filterOfferStatus}
                                    >
                                        <Select.Option key={`open`} value={`open`}>{`Open`}</Select.Option>
                                        <Select.Option key={`cancel`} value={`cancel`}>{`Cancel`}</Select.Option>
                                        <Select.Option key={`qc`} value={`qc`}>{`QC`}</Select.Option>
                                        <Select.Option key={`order`} value={`order`}>{`Order`}</Select.Option>
                                    </Select>
                                </Form.Item>

                                <Form.Item className={'padTop-10'} style={this.state.searchType !== "qc" ? {width: 140} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Metode</i>
                                    <Select
                                        showSearch
                                        placeholder="Pilih Metide"
                                        optionFilterProp="children"
                                        onChange={value => this.onFieldChange("filterPurchaseMethod", value)}
                                        value={this.state.filterPurchaseMethod}
                                    >
                                        <Select.Option key={`all`} value={``}>{`Semua Metode`}</Select.Option>
                                        <Select.Option key={`cash`} value={`cash`}>{`Tunai`}</Select.Option>
                                        <Select.Option key={`credit`} value={`credit`}>{`Kredit`}</Select.Option>
                                    </Select>
                                </Form.Item>
                                <Form.Item className={'padTop-10'} style={this.state.searchType !== "qc" ? {} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Tgl Awal</i><br/>
                                    <DatePicker defaultValue={moment(this.state.filterStartDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterStartDate", event)} format={'YYYY-MM-DD'}/>
                                </Form.Item>
                                <Form.Item className={'padTop-10'} style={this.state.searchType !== "qc" ? {} : {display: 'none'}}>
                                    <i className={`small-text-grey`}>Tgl Akhir</i><br/>
                                    <DatePicker defaultValue={moment(this.state.filterEndDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterEndDate", event)} format={'YYYY-MM-DD'}/>
                                </Form.Item>

                            </Form>
                            <Form.Item className={'padTop-20'}>
                                <Dropdown.Button
                                    type="primary"
                                    onClick={this.fetchOffer}
                                    icon={<DownOutlined/>}
                                    trigger={['click']}
                                    overlay={(
                                        <Menu>
                                            <Menu.Item key={1} onClick={event => this.changeSearchType("date")}>Pencarian Tanggal</Menu.Item>
                                            <Menu.Item key={2} onClick={event => this.changeSearchType("offer_code")}>Pencarian Kode Offer</Menu.Item>
                                            <Menu.Item key={3} onClick={event => this.changeSearchType("po_code")}>Pencarian Kode PO</Menu.Item>
                                            <Menu.Item key={4} onClick={event => this.changeSearchType("duplicate_idcard")}>Pencarian Duplikat IdCard</Menu.Item>
                                        </Menu>
                                    )}
                                ><SearchOutlined/> Cari Data</Dropdown.Button>
                            </Form.Item>
                        </Form>
                    </div>

                    <div style={{backgroundColor: "#f0f2f5"}}> &nbsp; </div>

                    <Table
                        title={() => <h3 style={{fontWeight: 'bold', fontSize: "110%"}}>Tabel List Offer <Tooltip title="Click untuk copy resume offer" color={'cyan'}><CopyOutlined className={'small-avatar-link'} onClick={event => this.copyResume()}/></Tooltip></h3>}
                        rowKey={'transaction_code'}
                        size={'small'}
                        scroll={{x: 'calc(500px + 50%)'}}
                        loading={this.state.processingFetchTableData}
                        columns={this.tableColumn}
                        dataSource={this.state.dataOffer}
                        pagination={{pageSize: this.state.pageSize}}
                        onChange={this.onChangeTable}
                    />
                </MainLayout>

                <Modal
                    open={this.state.showModalDetailStock}
                    title={`Detail Offer` + (this.state.chosenOfferRow?.qc_status ? ` (telah di QC)` : "")}
                    onOk={() => this.setState({showModalDetailStock: false})}
                    onCancel={() => this.setState({showModalDetailStock: false})}
                    width={'90%'}
                    style={{top: 10}}
                    cancelText={'Tutup'} okText={false}
                    footer={[
                        <Button style={(!this.state.chosenOfferRow?.qc_status) && (this.state.chosenOfferRow?.offer_status === "OPEN") ? {} : {display: 'none'}} key="doQc" type="primary" onClick={this.buttonQcHit}>Lakukan QC</Button>,
                        <Button style={(!this.state.chosenOfferRow?.qc_status) && (!this.state.chosenOfferRow?.bill_code) && (this.state.chosenOfferRow?.offer_status === "OPEN") ? {} : {display: 'none'}} key="createBill" danger={true} type="primary" onClick={() => this.setState({showModalDetailStock: false, createPaymentShow: true, createPaymentProcess: false, additionalCostType: (this.state.chosenOfferRow?.agent_code === "NO_DATA") ? "BILL" : "INVOICE"})}>
                            Buat Bill
                        </Button>,
                        <Button key="back" type="default" onClick={() => this.setState({showModalDetailStock: false})}>Tutup</Button>,
                    ]}
                >
                    <DetailOffer companyCode={this.state.companyCode} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    open={this.state.qcShow}
                    title="QC Offer"
                    style={{top: 20}}
                    width={"80%"}
                    onCancel={() => this.setState({qcShow: false, qcProcess: false,})}
                    footer={[
                        <Button key="0" disabled={this.state.ocrProcess} loading={this.state.qcProcess} type="primary" onClick={this.finalQc}>Lakukan QC</Button>,
                        <Button key="1" type="default" onClick={() => this.setState({qcShow: false, qcProcess: false,})}>Tutup</Button>,
                    ]}
                >
                    <Row>
                        <Col xs={24} xl={12}>
                            <Row>
                                <Col span={12}>
                                    <div>
                                        <i className={`small-text-grey`}>Nama Pemilik:</i><br/>
                                        {this.state.chosenOfferRow.owner_full_name}<br/>
                                    </div>
                                    <div>
                                        <i className={`small-text-grey`}>Nomor KTP Pemilik:</i><br/>
                                        {this.state.chosenOfferRow.owner_id_card_number}<br/><br/>
                                    </div>
                                </Col>
                                <Col span={12}>
                                    <div style={this.state.ocrResultName || this.state.ocrResultNumber ? {} : {display: 'none'}}>
                                        <div>
                                            <i className={`small-text-grey`}>Nama Pemilik <b>OCR</b>:</i><br/>
                                            {this.state.ocrResultName}<br/>
                                        </div>
                                        <div>
                                            <i className={`small-text-grey`}>Nomor KTP Pemilik <b>OCR</b>:</i><br/>
                                            {this.state.ocrResultNumber}<br/><br/>
                                        </div>
                                    </div>
                                    <div style={this.state.ocrResultName || this.state.ocrResultNumber ? {display: 'none'} : {textAlign: "center"}}>
                                        <Spin style={{marginTop: 20}}/><br/><span>Loading OCR Result...</span>
                                    </div>

                                </Col>
                            </Row>
                            <i className={`small-text-grey`}>Image KTP Pemilik:</i><br/>
                            <img style={{width: "80%", maxHeight: "300px"}} src={this.state.chosenOfferRow.owner_id_card_image} alt="please attach file then crop"/>
                        </Col>
                        <Col xs={24} xl={12}>
                            Apakah anda yakin untuk merubah status offer {this.state?.chosenOfferCode} menjadi telah di QC ?
                            <br/><br/>
                            <Form.Item className={'padTop-10'}>
                                <i className={`small-text-grey`}>Default Type Tagihan Biaya Tambahan:</i>
                                <Select
                                    style={{width: "100%"}}
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("additionalCostType", value)}
                                    value={this.state.additionalCostType}
                                >
                                    <Select.Option key={`BILL`} value={`BILL`}>{`Bill`}</Select.Option>
                                    <Select.Option key={`INVOICE`} value={`INVOICE`}>{`Invoice`}</Select.Option>
                                </Select>
                            </Form.Item>

                            <Divider style={{padding: 10, margin: 0}}/>
                            <Form.Item>
                                <i className={`small-text-grey`}>BPDAB:</i>
                                <Select
                                    style={{width: "100%"}}
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("additionalCostBpdab", value)}
                                    value={this.state.additionalCostBpdab}
                                >
                                    <Select.Option key={`BILL`} value={`BILL`}>{`Bill`}</Select.Option>
                                    <Select.Option key={`INVOICE`} value={`INVOICE`}>{`Invoice`}</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <i className={`small-text-grey`}>BPDAD:</i>
                                <Select
                                    style={{width: "100%"}}
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("additionalCostBpdad", value)}
                                    value={this.state.additionalCostBpdad}
                                >
                                    <Select.Option key={`BILL`} value={`BILL`}>{`Bill`}</Select.Option>
                                    <Select.Option key={`INVOICE`} value={`INVOICE`}>{`Invoice`}</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <i className={`small-text-grey`}>BPKON:</i>
                                <Select
                                    style={{width: "100%"}}
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("additionalCostBpkon", value)}
                                    value={this.state.additionalCostBpkon}
                                >
                                    <Select.Option key={`BILL`} value={`BILL`}>{`Bill`}</Select.Option>
                                    <Select.Option key={`INVOICE`} value={`INVOICE`}>{`Invoice`}</Select.Option>
                                    <Select.Option key={`CASH`} value={`CASH`}>{`Cash`}</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <i className={`small-text-grey`}>Biaya Biro Jasa:</i>
                                <Select
                                    style={{width: "100%"}}
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("additionalBureauFee", value)}
                                    value={this.state.additionalBureauFee}
                                >
                                    <Select.Option key={`BILL`} value={`BILL`}>{`Bill`}</Select.Option>
                                    <Select.Option key={`INVOICE`} value={`INVOICE`}>{`Invoice`}</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <i className={`small-text-grey`}>PDI:</i>
                                <Select
                                    style={{width: "100%"}}
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("additionalPdi", value)}
                                    value={this.state.additionalPdi}
                                >
                                    <Select.Option key={`BILL`} value={`BILL`}>{`Bill`}</Select.Option>
                                    <Select.Option key={`INVOICE`} value={`INVOICE`}>{`Invoice`}</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <i className={`small-text-grey`}>PELWIL:</i>
                                <Select
                                    style={{width: "100%"}}
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("additionalPelwil", value)}
                                    value={this.state.additionalPelwil}
                                >
                                    <Select.Option key={`BILL`} value={`BILL`}>{`Bill`}</Select.Option>
                                    <Select.Option key={`INVOICE`} value={`INVOICE`}>{`Invoice`}</Select.Option>
                                    <Select.Option key={`CASH`} value={`CASH`}>{`Cash`}</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <i className={`small-text-grey`}>TOL:</i>
                                <Select
                                    style={{width: "100%"}}
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("additionalTol", value)}
                                    value={this.state.additionalTol}
                                >
                                    <Select.Option key={`BILL`} value={`BILL`}>{`Bill`}</Select.Option>
                                    <Select.Option key={`INVOICE`} value={`INVOICE`}>{`Invoice`}</Select.Option>
                                </Select>
                            </Form.Item>
                            <Form.Item>
                                <i className={`small-text-grey`}>Perbedaan Otr:</i>
                                <Select
                                    style={{width: "100%"}}
                                    showSearch
                                    placeholder="Pilih Status"
                                    optionFilterProp="children"
                                    onChange={value => this.onFieldChange("additionalDifferenceOtr", value)}
                                    value={this.state.additionalDifferenceOtr}
                                >
                                    <Select.Option key={`BILL`} value={`BILL`}>{`Bill`}</Select.Option>
                                    <Select.Option key={`INVOICE`} value={`INVOICE`}>{`Invoice`}</Select.Option>
                                </Select>
                            </Form.Item>
                        </Col>
                    </Row>
                </Modal>


                <Modal
                    open={this.state.createPaymentShow}
                    title="Create Bill"
                    onCancel={() => this.setState({createPaymentShow: false, createPaymentProcess: false,})}
                    footer={[
                        <Button key="0" loading={this.state.createPaymentProcess} type="primary" onClick={this.createBill}>Buat Bill</Button>,
                        <Button key="1" type="default" onClick={() => this.setState({createPaymentShow: false, createPaymentProcess: false,})}>Tutup</Button>,
                    ]}
                >
                    Apakah anda yakin untuk membuat bill pada {this.state?.chosenOfferCode} ?

                    <div style={this.state.chosenOfferRow?.agent_code === "NO_DATA" ? {} : {display: 'none'}}>
                        <br/>
                        <i style={{color: '#9a2626'}}>Warning</i><br/>
                        *OFFER yang telah dibuat BILL/TAGIHAN. Tidak dapat diakusisi oleh agen
                    </div>
                </Modal>

                <Modal
                    open={this.state.detailOrderModal}
                    title="Detail Order"
                    onCancel={() => this.setState({detailOrderCode: "", detailOrderModal: false})}
                    footer={[<Button key="1" type="primary" onClick={() => this.setState({detailOrderCode: "", detailOrderModal: false})}>Tutup</Button>]}
                >
                    <DetailOrder dealerCode={this.state.dealerCode} orderCode={this.state.detailOrderCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    style={{top: 10}}
                    open={this.state.showModalUpdateOwner}
                    title="Update Owner KTP"
                    onCancel={() => this.setState({showModalUpdateOwner: false})}
                    footer={[]}
                >
                    <UpdateOwnerOffer type={`offer`} onCloseUpdateOwnerIdCardProps={this.onCloseEditModal} companyCode={this.state.companyCode} dealerCode={this.state.dealerCode} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    open={this.state.showModalUpdateOrderMaker}
                    title="Update Pemesan KTP"
                    onCancel={() => this.setState({showModalUpdateOrderMaker: false})}
                    footer={[]}
                >
                    <UpdateOrderMakerOffer onCloseUpdateOrderMakerIdCardProps={this.onCloseEditModal} companyCode={this.state.companyCode} dealerCode={this.state.dealerCode} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    open={this.state.showModalUpdateShippingAddress}
                    title="Update Shipping Address"
                    style={{top: 10}}
                    width={'80%'}
                    onCancel={() => this.setState({showModalUpdateShippingAddress: false})}
                    footer={[]}
                >
                    <UpdateShippingAddressOffer onCloseUpdateShippingAddressProps={this.onCloseEditModal} companyCode={this.state.companyCode} dealerCode={this.state.dealerCode} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    open={this.state.showModalUpdateVehiclePromo}
                    title={`Update Kendaraan & Promo`}
                    style={{top: 10}}
                    onCancel={() => this.setState({showModalUpdateVehiclePromo: false})}
                    footer={[]}
                    width={'90%'}
                >
                    <UpdateVehicleAndPromo update_bill={false} onCloseUpdateVehicleAndPromo={this.onCloseEditModal} companyCode={this.state.companyCode} dealerCode={this.state.dealerCode} offerCode={this.state.chosenOfferCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    open={this.state.showModalUpdatePhoneNumber}
                    style={{top: 10}}
                    title="Update Phone Number"
                    onCancel={() => this.setState({showModalUpdatePhoneNumber: false})}
                    footer={[]}
                >
                    <UpdatePhoneNumber
                        type={`offer`}
                        companyCode={this.state.companyCode}
                        onCloseUpdatePhoneNumberProps={this.onCloseEditModal}
                        offerCode={this.state.chosenOfferCode}
                        time={Math.floor(+new Date() / 1000)}
                        ownerPhoneNumber={this.state.chosenOfferRow?.owner_phone_number ?? ""}
                        ownerAlternativePhoneNumber={this.state.chosenOfferRow?.owner_alternative_phone_number ?? ""}
                        orderMakerPhoneNumber={this.state.chosenOfferRow?.order_maker_phone_number ?? ""}
                        poPhoneNumber={this.state.chosenOfferRow?.po_phone_number ?? ""}
                    />
                </Modal>

                <Modal
                    open={this.state.showModalDetailIdCard}
                    title={`Detail ID CARD`}
                    onOk={() => this.setState({showModalDetailIdCard: false})}
                    onCancel={() => this.setState({showModalDetailIdCard: false})}
                    cancelText={'Tutup'} okText={false}
                    footer={[<Button key="back" type="default" onClick={() => this.setState({showModalDetailIdCard: false})}>Tutup</Button>]}
                >
                    <CustomerIdCardOcr idCardNumber={this.state.chosenIdCardNumber} idCardImage={this.state.chosenIdCardImage} time={Math.floor(+new Date() / 1000)}/>
                </Modal>

                <Modal
                    open={this.state.showModalDetailCreatePoPdf}
                    title={`PO ` + this.state.chosenOfferCode}
                    onOk={() => this.setState({showModalDetailCreatePoPdf: false})}
                    onCancel={() => this.setState({showModalDetailCreatePoPdf: false})}
                    style={{top: 10}}
                    cancelText={'Tutup'} okText={false}
                    footer={[
                        <a target={`_blank`} href={`https://asia-southeast1-autotrimitra.cloudfunctions.net/api-offer-otodis--create-pdf/po/generate-pdf?company=amarta&spk_code=${this.state.chosenOfferCode}&dealer_name=${this.state.attorneyDealerName}&engine_number=${this.state.attorneyEngineNumber}&token=asc8asdasaskjdhas87asdasd&force_download=true&notes=${this.state.poNotes}`}>
                            <Button onClick={() => this.setState({showModalDetailCreatePoPdf: false})} key="1" type="primary"><FilePdfOutlined/> Download PO</Button>
                        </a>,
                        <Button style={{marginLeft: 7}} key="2" type="default" onClick={() => this.setState({showModalDetailCreatePoPdf: false})}>
                            Tutup
                        </Button>,
                    ]}
                >
                    <Divider orientation="left" plain style={{marginTop: 10, marginBottom: 10}}>
                        <span className={`divider-data-konsumen`}>Data PO</span>
                    </Divider>
                    <Form.Item>
                        <i className={`small-text-grey`}>Catatan PO</i>
                        <TextArea value={this.state.poNotes} placeholder="Catatan PO" onChange={(event) => this.onFieldChange("poNotes", event.target.value)} autoSize={{minRows: 2, maxRows: 3}}></TextArea>
                    </Form.Item>

                    <Divider orientation="left" plain style={{marginTop: 10, marginBottom: 10}}>
                        <span className={`divider-data-konsumen`}>Data Surat Kuasa</span>
                    </Divider>
                    <Form.Item>
                        <i className={`small-text-grey`}>Nama Dealer</i>
                        <Input value={this.state.attorneyDealerName} onChange={event => this.onFieldChange("attorneyDealerName", event.target.value)} placeholder="Nama Dealer"/>
                    </Form.Item>
                    <Form.Item>
                        <i className={`small-text-grey`}>Nomor Mesin</i>
                        <Input value={this.state.attorneyEngineNumber} onChange={event => this.onFieldChange("attorneyEngineNumber", event.target.value)} placeholder="Nomor Mesin"/>
                    </Form.Item>
                </Modal>

                <Modal
                    open={this.state.showModalDetailCreateSnsPdf}
                    title={`SNS ` + this.state.chosenOfferCode}
                    onOk={() => this.setState({showModalDetailCreateSnsPdf: false})}
                    onCancel={() => this.setState({showModalDetailCreateSnsPdf: false})}
                    style={{top: 10}}
                    cancelText={'Tutup'} okText={false}
                    footer={[
                        <a target={`_blank`} href={`https://asia-southeast1-autotrimitra.cloudfunctions.net/api-offer-otodis--create-pdf/sns/generate-pdf?company=${this.state.companyCode}&spk_code=${this.state.chosenOfferCode}&force_download=true`}>
                            <Button onClick={() => this.setState({showModalDetailCreateSnsPdf: false})} key="1" type="primary"><FilePdfOutlined/> Download SNS</Button>
                        </a>,
                        <Button style={{marginLeft: 7}} key="2" type="default" onClick={() => this.setState({showModalDetailCreateSnsPdf: false})}>
                            Tutup
                        </Button>,
                    ]}
                >
                    <div>
                        Klik tombol Download SNS untuk mengunduh dokumen SNS.
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(ListOffer), 13));